import apiRequest from './client';

// Journal d'audit (superadmin, ou staff limite avec le menu "Journal d'audit"
// accorde) — cf. auditlog.views.AuditLogListView. Filtres tous optionnels.
export const fetchAuditLog = ({ company, actorType, action, modelName, dateFrom, dateTo } = {}) => {
  const qs = [];
  if (company) qs.push(`company=${encodeURIComponent(company)}`);
  if (actorType) qs.push(`actor_type=${encodeURIComponent(actorType)}`);
  if (action) qs.push(`action=${encodeURIComponent(action)}`);
  if (modelName) qs.push(`model_name=${encodeURIComponent(modelName)}`);
  if (dateFrom) qs.push(`date_from=${encodeURIComponent(dateFrom)}`);
  if (dateTo) qs.push(`date_to=${encodeURIComponent(dateTo)}`);
  return apiRequest(`/audit-log/${qs.length ? `?${qs.join('&')}` : ''}`);
};
